import styled from "styled-components";
import Colors from "../../themes/Colors";
import Fonts from "../../themes/Fonts";
import { fadeIn } from "../Common/CommonStyles";

export const Button = styled.button`
  background-color: ${(props) =>
    props?.backGroundColor || Colors.primaryPrimera};
  color: ${(props) => props?.textColor || Colors.white};
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  font-weight: ${(props) => props.weight || "normal"};
  font-size: ${(props) => props.fontSize || "13px"};
  padding: 10px 20px;
  border: ${(props) => props.border || "none"};
  border-radius: 25px;
  cursor: pointer;
  width: ${(props) => props.width || ""};
  height: ${(props) => props.height || "40px"};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: ${(props) => props?.hoverColor || Colors.primaryPrimera};
    color: ${(props) => props?.hoverTextColor || Colors.white};
  }

  &:focus {
    outline: none;
  }

  &:active {
    background-color: ${(props) =>
      props?.backGroundColor || Colors.primaryPrimera};
  }

  @media (max-width: 844px) {
    font-size: ${(props) => props.fontSize || "14px"};
    width: 290px;
    height: auto;
    animation: ${fadeIn} 0.5s ease-in;
  }

  @media (max-width: 320px) {
    animation: ${fadeIn} 0.5s ease-in;
    width: 200px;
  }
  &:disabled {
    background-color: ${Colors.gray || "#cccccc"};
    color: ${Colors.darkGray || "#666666"};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
